import { details } from '../../../api/common';
import { printOut } from '../components/print/print';
import * as analytics from '../../../analytics';
import { showNotificationLayer } from '../../../actions/notification';

const _command = params =>
  async dispatch => {
    try
    {
      dispatch(
        showNotificationLayer('Gerando arquivo. Aguarde...')
      );

      const { data: manifestationDetail } = await details({
        id: params.id,
        path: 'manifestation.php',
      });

      console.log('manifestationDetail', manifestationDetail);

      printOut({
        data: manifestationDetail,
        fileName: `manifestacao-${manifestationDetail.protocol}.html`,
      });
    }
    catch(error)
    {
      dispatch(
        showNotificationLayer('Ops... não conseguimos gerar o arquivo.')
      )
    }
  }

export const generatePrint = params => {
  //ga
  analytics.registerEvent({
    category: analytics.categories.manifestation,
    action: analytics.actions.manifestationPrint,
  });

  return _command(params);
}
